import { createFeedback, validFeedback } from './feedback'

export { createFeedback, validFeedback }



// WEBPACK FOOTER //
// ./src/features/Feedback/models/index.js